import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { Wso2CoreService } from '@services/wso2-core.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { cpfValidator } from 'src/app/validators/cpf-validator';
import { DomUtilsService } from '@utils/DomUtilsService';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { SuccessGenericoComponent } from '../../components/success-generico/success-generico.component';
import { ErrorGenericoComponent } from '../../components/error-generico/error-generico.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { NgxMaskDirective } from 'ngx-mask';
import { SelectComponent } from '../../components/select/select.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';
import { NgClass, AsyncPipe } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-editar-contato',
    templateUrl: './editar-contato.component.html',
    styleUrls: ['./editar-contato.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, SuccessGenericoComponent, ErrorGenericoComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, NgxMaskDirective, SelectComponent, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgClass, RouterLink, FooterComponent, AsyncPipe, UsuarioPermissaoPipe]
})
export class EditarContatoComponent implements OnInit {
  public idEmpresaLogada: string = localStorage.idEmpresaLogada;
  public dadosContato: any = null;
  public formulario: UntypedFormGroup;
  public formularioChanges = false;
  public departamentos: any = null;
  public departamentoOptions: any = null;
  public cargos: any = null;
  public cargosOptions: any = null;

  // VARIAVEIS DOS ALERTS
  public alertLoading = false;
  public alertSucesso = false;
  public alertError = false;
  public mensagemErro = '';
  public idContato: string;
  public dataValidator = true;

  public idContatoPermissao: any;

  constructor(
    private readonly formularioBuilder: UntypedFormBuilder,
    private readonly service: DadosEmpresaService,
    public rota: Router,
    public rotaAtiva: ActivatedRoute,
    private readonly Toastr: ToastrService,
    public usuarioPermissaoService: UsuarioPermissaoService,
    private readonly wso2CoreService: Wso2CoreService,
    private readonly domUtils: DomUtilsService
  ) {}

  ngOnInit(): void {
      this.idContato = sessionStorage.idContatoEditando;
      this.consultaDepartamentos();
      this.consultaCargos();
      this.consultaDadosContato();
  }

  consultaDadosContato() {
    this.dadosContato = null;

    this.service.getDadosContato(this.idContato).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.idContatoPermissao = response.response;
        if (response.status === 'OK') {
          this.dadosContato = response.response;
          this.contruirFormulario();
          this.validadata();
        } else {
          this.dadosContato = false;
        }
      },
      error: (erro: any) => {
        this.dadosContato = false;
        console.error(erro);
      }
    });
  }

  contruirFormulario() {
    this.formulario = this.formularioBuilder.group({
      nomeCompleto: [
        this.dadosContato.nomeContato,
        Validators.compose([Validators.required]),
      ],
      cpf: [
        this.dadosContato.cpf,
        Validators.compose([Validators.required, cpfValidator()]),
      ],
      genero: [
        this.dadosContato.sexo,
        Validators.compose([Validators.required]),
      ],
      dataNascimento: [
        (this.dadosContato.dataNascimento ?? ''),
      ],
      email: [
        this.dadosContato.emailContato,
        Validators.compose([Validators.required]),
      ],
      telefone: [
        this.dadosContato.telefoneDDD + this.dadosContato.telefoneNumero,
        Validators.compose([Validators.required]),
      ],
      ramal: [this.dadosContato.telefoneRamal],
      departamento: [
        `${this.dadosContato.idDepartamento}-${this.dadosContato.departamento}`,
        Validators.compose([Validators.required]),
      ],
      cargo: [
        `${this.dadosContato.idCargo}-${this.dadosContato.cargo}`,
        Validators.compose([Validators.required]),
      ],
    });

    this.formulario.valueChanges.subscribe((val) => {
      this.formularioChanges = true;
    });

  }

  consultaDepartamentos() {
    this.service.consultaDepartamentos().pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.departamentos = response.response;
          this.departamentoOptions = this.departamentos.map(departamento => {
            return {
              value: `${departamento.idDeptoWeb}-${departamento.descDeptoWeb}`,
              description: departamento.descDeptoWeb
            };
          });
        } else {
          this.departamentos = false;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.departamentos = false;
      }
    });
  }

  consultaCargos() {
    this.service.consultaCargos().pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.cargos = response.response;
          this.cargosOptions = this.cargos.map((cargo) => {
            return {
              value: `${cargo.idCargosWeb}-${cargo.descCargosWeb}`,
              description: cargo.descCargosWeb
            };
          });
        } else {
          this.cargos = false;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.cargos = false;
      }
    });
  }

  // API FINAL PARA ATUALIZADOR (editar) os dados do CONTATO

  atualizarDadosContato() {
    const objContato = {
        name: this.formulario.value.nomeCompleto,
        ddd: this.formulario.value.telefone.slice(0, 2),
        phoneNumber: this.formulario.value.telefone.slice(2),
        email: this.formulario.value.email,
        companyPositionId: this.formulario.value.cargo.split('-')[0],
        cpf: this.formulario.value.cpf,
        departmentId: this.formulario.value.departamento.split('-')[0],
        gender: this.formulario.value.genero,
        birthDate: moment(this.formulario.value.dataNascimento).format('DD/MM/yyyy'),
        extensionLine: this.formulario.value.ramal,
    };

    this.alertLoading = true;

    this.wso2CoreService.updateContact(this.idContato, objContato).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if (response.status === 'OK') {
          this.alertSucesso = true;
        } else {
          this.alertError = true;
          this.mensagemErro = response.mensagem;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.alertLoading = false;
        this.alertError = true;
        this.mensagemErro = erro.error.mensagem;
      }
    });
  }

  voltarAbaContatos() {
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('contatosTab', 3, 1500);
  }

  // Fechar o alerta de sucesso, clicando no botão OK
  fecharAlertSucesso(evento: string) {
    this.alertSucesso = false;
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('contatosTab', 4, 1200);
  }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) {
    this.alertError = false;
  }

  somenteNumeros(e: any) {
    const charCode = e.charCode ?? e.keyCode;
    
    if (charCode != 8 && charCode != 9) {
      const max = 10;

      if (charCode < 48 || charCode > 57 || e.target.value.length >= max) {
        return false;
      }
    }
  }

  validadata() {
    let data = this.formulario.value.dataNascimento;

    const hoje = new Date();
    const nasc = new Date(data);
    let idade = hoje.getFullYear() - nasc.getFullYear();
    const m = hoje.getMonth() - nasc.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
      idade--;
    }

    if (idade < 0) {
      this.Toastr.error('Data de Nascimento Inválida !', '', {
        timeOut: 2000,
      });
      this.dataValidator = false;
    }

    if (idade >= 14 && idade < 80) {
      this.dataValidator = true;
    }

    if (idade < 14 && idade >= 0) {
      this.Toastr.error('Idade mínima deve ser 14 anos', '', {
        timeOut: 2000,
      });
      this.dataValidator = false;
    }

    if (idade > 80) {
      this.Toastr.error('Idade máxima deve ser 80 anos', '', {
        timeOut: 2000,
      });
      this.dataValidator = false;
    }
  }
  get formControl() {
    return this.formulario.controls;
  }
}
